import { routeDescriptionLenses } from 'root/src/client/logic/route/lenses'
import routeDescriptions from 'root/src/shared/descriptions/routes'

const { viewNoLoginRedirect } = routeDescriptionLenses

export default (state, { routeId }) => viewNoLoginRedirect(routeId, routeDescriptions)
